// Third Party
import cx from 'classnames';

export const getTypographySelectStylesAsClassName = (
  showLabel: boolean,
  disabled: boolean
): string => {
  return cx(
    'flex',
    'items-center',
    'box-content',
    'min-h-[24px]',
    'pt-[18px]',
    'px-4',
    'pb-1',
    'text-gray-dark',
    'cursor-pointer',
    'whitespace-nowrap',
    'overflow-hidden',
    'text-ellipsis',
    'max-w-full',
    {
      'relative bottom-2': !showLabel,
      'cursor-not-allowed': disabled,
    }
  );
};
